<template>
  <div id="app">
     <div class="box_cont" v-show="isFlag">
      <div class="header">
        <div class="top">
          <div class="top-nav">
            <router-link tag="span" @click.native="clickSpan('A')"  :class="{'active' : activeId == 'A'}" to="/home">首页</router-link>
            <router-link tag="span" @click.native="clickSpan('B')"  :class="{'active' : activeId == 'B'}" to="/mywork">我的作品</router-link>
            <router-link tag="span" to>
              <el-dropdown>
                <span class="el-dropdown-link">
                  资料下载 <img src="./assets/images/arrow-down.png" alt class="img"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item style="border-bottom:1px solid #999999;width:150px" @click.native="toUpload">学校承诺函下载</el-dropdown-item>
                  <el-dropdown-item @click.native="toUploads">作品汇总表模板下载</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </router-link>
            <router-link tag="span" @click.native="clickSpan('C')"  :class="{'active' : activeId == 'C'}" to="/activityRule">活动规则</router-link>
          </div>
        <div class="top-right">
          <el-dropdown>
                <span class="el-dropdown-link">
                   <img :src="'https://static.sdetv.com.cn'+userInfos.avatar" alt class="imgs"/> <img src="./assets/images/arrow-down.png" alt class="img"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="$router.push({ path: '/infoData' })" style="border-bottom:1px solid #999999;width:150px">{{userInfo.school}}<i class="el-icon-success" style="color:red;margin-left:4px"></i></el-dropdown-item>
                  <el-dropdown-item @click.native="toLogin">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
        </div>
      </div>
      <div class="border"></div>
    </div>
    </div>
    <div class="view_info">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { USERINFO,USERINFOS } from "./cookie/cookie.js";
export default {
  data() {
    return {
      navShow: false,
      navShows:false,
      dialogVisible: false,
      isFlag:false,
      activeId:'A',
      userInfo:{},
      userInfos:{}
    };
  },
  methods: {
    chang(val){
       console.log(val)
    },
    handerOver() {
      this.navShow = true;
    },
    handerLeave() {
      this.navShow = false;
    },
    handerOvers() {
      this.navShows = true;
    },
    handerLeaves() {
      this.navShows = false;
    },
    clickSpan(val){
      console.log(val)
      this.activeId = val
    },
    toUpload(){
      var href="http://static.sdetv.com.cn/uploads/chengnuoshu.doc"
　　　window.open(href,'_self');
    },
    toUploads(){
       var href="http://static.sdetv.com.cn/uploads/baomingbiao.doc"
　　　window.open(href,'_self');
    },
    handerSearch() {
      this.$router.push({ path: "/Search" });
    },
    toLogin(){
       this.$confirm('退出当前账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$cookie.set(USERINFO, '', "1d")
          this.$router.push({ path: "/login" });
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    }
    //  登录注册按钮
    // handlerLogin() {
    //   this.$router.push({ path: "/Login" });
    // },
  },
  mounted() {},
  watch: {
    $route(to, from) {
      console.log(to.path)
      // this.userInfo = this.$cookie.get(USERINFO);
      // localStorage.setItem("title", to.meta.title);
      if(to.path == "/home"){
        console.log(this.$cookie.get(USERINFO))
        this.userInfos = this.$cookie.get(USERINFOS);
        this.$nextTick(() => {
        this.userInfo = this.$cookie.get(USERINFO);
      })
      }
      if (to.path == "/") {
        this.isFlag = false;
      } else {
        this.isFlag = true;
      }
    },
  },
  created() {
    console.log(this.$cookie.get(USERINFO))
    // this.userInfo = this.$cookie.get(USERINFO);
    this.$nextTick(() => {
       if(!this.$cookie.get(USERINFO)){
         this.userInfo= {
           avatar:'123',
           nickname:'习悦多'
         }
       }else{
         this.userInfo = this.$cookie.get(USERINFO);
       }
      });
    console.log(this.userInfo)
  },
};
</script>

 <style lang="scss">
 html {
  font-size: 10px;
  width: 100%;
  height: 100%;
  overflow: auto;
  min-width: 1280px;

  @media screen and (min-width: 1280px) and (max-width: 1369px) {
    font-size: 11px;
  }

  @media screen and (min-width: 1369px) and (max-width: 1440px) {
    font-size: 12px;
  }

  @media screen and (min-width: 1441px) and (max-width: 1600px) {
    font-size: 14px;
  }

  @media screen and (min-width: 1601px) and (max-width: 1800px) {
    font-size: 16px;
  }

  @media screen and (min-width: 1801px) and (max-width: 1920px) {
    font-size: 16px;
  }

  @media screen and (min-width: 1921px) {
    font-size: 20px;
  }
}

// /* #app {
//   font-family: "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   margin-top: 60px;
// } */
#app{
  width: 100%;
  text-align: center;
}
* {
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
  /* top: 0; */
  bottom: 0;
}   
    .view_info{
      position: absolute;
      top: 150px;
      z-index: 99;
      width: 100%;
      font-size: 14px;
    }
    .box_cont{
      background: url('./assets/images/home_bg.png')no-repeat;
      background-size:100% 100%;
      font-size: 14px;
      min-width: 1440px;
      height: 600px;
      z-index: 99;
      // margin-left: 300px;
        .header {
          width: 100%;
          height: 70px;
          background-color: rgba(255, 255, 255, 0) !important;
    // border: 1px solid rgba(187, 187, 187, 1);
    // box-sizing: border-box;
        .border{
          // top: 82px;
          opacity: 0.38;
          color: rgba(80, 80, 80, 1);
          background-color: rgba(255, 255, 255, 1);
          font-size: 14px;
          width: 100%;
          height: 1px;
          text-align: center;
        }
        .top {
          padding: 0 160px;
          min-width: 1440px;
          height: 70px;
          color: #ffffff;
          font-size: 18px;
          background-color: rgba(255, 255, 255, 0) !important;
          margin: 0 auto;
          display: flex;
          // justify-content: space-between;
          align-items: center;
          .top-logo {
            width: 96px;
            height: 66px;

          }
          .top-nav {
            display: flex;
            margin-left: 30%;
            span {
              margin-right: 60px;
              cursor: pointer;
              display: block;
              height: 70px;
              line-height: 70px;
              width: 120px;
              text-align: center;
              img {
                // vertical-align: 0;
                width: 28px;
                height: 28px;
                vertical-align:middle;
              }
              // .imgs{
              //   vertical-align:middle;
              // }
              .show {
                position: absolute;
                width: 200px;
                height: 84px;
                // left: 20px;
                top: 70px;
                color: #000000;
              ul {
                width: 100%;
                height: 100%;
                // background-color: #fff;

                transition: opacity 1s;
                list-style: none;

                li {
                  height: 42px;
                  border-bottom: 1px solid #ccc;
                  text-align: center;
                  line-height: 48px;
                  font-size: 15px;
                  color: 000;
                  background-color: #fff;
                }
                li:hover {
                  cursor: pointer;
                }
                li:last-of-type {
                  border: 0;
                  border-bottom-right-radius: 10px;
                  border-bottom-left-radius: 10px;
                }
                // ul:last-child {
                //   border: 0;
                // }
              }
          }
          .show {
            animation: fade-in; /*动画名称*/
            animation-duration: 0.8s; /*动画持续时间*/
            -webkit-animation: fade-in 0.8s; /*针对webkit内核*/
          }
  @keyframes fade-in {
    0% {
      opacity: 0;
    } /*初始状态 透明度为0*/

    40% {
      opacity: 0;
    } /*过渡状态 透明度为0*/

    100% {
      opacity: 1;
    } /*结束状态 透明度为1*/
  }

  @-webkit-keyframes fade-in {
    /*针对webkit内核*/

    0% {
      opacity: 0;
    }

    40% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
            }
          }
          .top-right {
            margin-left: 100px;
            // .el-dropdown-link{
            //   height: 70px;
            // }
           .imgs{
             width: 65px;
             height: 65px;
             border-radius: 50%;
           }
           .el-icon-arrow-down:before{
             width: 32px;
             height: 32px;
           }
           .img{
            //  vertical-align:middle;
            margin-bottom:14px
           }
            .show {
                position: absolute;
                width: 200px;
                height: 84px;
                // left: 20px;
                top: 20px;
                color: #000000;
              ul {
                width: 100%;
                height: 100%;
                // background-color: #fff;

                transition: opacity 1s;
                list-style: none;

                li {
                  height: 42px;
                  border-bottom: 1px solid #ccc;
                  text-align: center;
                  line-height: 48px;
                  font-size: 15px;
                  color: 000;
                  background-color: #fff;
                }
                li:hover {
                  cursor: pointer;
                }
                li:last-of-type {
                  border: 0;
                  border-bottom-right-radius: 10px;
                  border-bottom-left-radius: 10px;
                }
                // ul:last-child {
                //   border: 0;
                // }
              }
          }
          .show {
            animation: fade-in; /*动画名称*/
            animation-duration: 0.8s; /*动画持续时间*/
            -webkit-animation: fade-in 0.8s; /*针对webkit内核*/
          }
          }
          .active {
            // color: #3674f3;
            font-weight: bold;
            border-bottom: 2px solid #fff;
            img {
              vertical-align: none;
            }
          }
        }
      }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue